export default {
  cashBookTemporary: []
}
